export default {
  cashBookTemporary: []
}
